import { ViewmodelAgreementPreview } from '@acordocertobr/reneg-offers-hub';

/**
 * Lista completa com todos os tipos de acordos e cenários
 * Inclui: acordos ativos, pagos, cancelados, diferentes métodos de pagamento, etc.
 */
export const mockAgreementsComplete: ViewmodelAgreementPreview[] = [
  // Acordo ativo com parcela do mês atual (boleto) - primeira parcela de 5
  {
    id: 25855001,
    uuid: 'asdsfg',
    creditor: {
      slug: 'acordocerto',
      name: 'AcordoCerto',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/e3835fe636/acordo-certo.svg',
      systemSlug: 'acordocerto',
    },
    status: 'ACTIVE',
    value: 2000,
    createdAt: '2025-09-09T03:00:00.000Z',
    contract: '020250909',
    product: 'Cartão de Crédito',
    installmentsNumber: 5,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700574,
      uuid: 'e4bfaa3cea64f3f2f2a8224a4b45c10ede2e0f2c0ee1f69be1a05d05cd8c14a68a744ca7cb736f6ca221',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 1,
      maxPaymentDate: '2025-09-12T03:00:00.000Z',
      dueDate: '2025-09-12T03:00:00.000Z',
      value: 44.5,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700575,
      uuid: '0043de02381a9292db97092bf792ff6c40a218ea2122d793e53ba233624bdc3791f3721b68be8d1d2dd5',
      paymentMethod: 'BILLET',
      status: 'UNAVAILABLE',
      number: 2,
      maxPaymentDate: '2025-10-12T03:00:00.000Z',
      dueDate: '2025-10-12T03:00:00.000Z',
      value: 44.5,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700574,
      uuid: 'e4bfaa3cea64f3f2f2a8224a4b45c10ede2e0f2c0ee1f69be1a05d05cd8c14a68a744ca7cb736f6ca221',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 1,
      maxPaymentDate: '2025-09-12T03:00:00.000Z',
      dueDate: '2025-09-12T03:00:00.000Z',
      value: 44.5,
      hidePaymentDueDate: false,
    },
  },

  // Acordo ativo na última parcela deste mês (PIX)
  {
    id: 25855002,
    uuid: 'uuid-nubank-002',
    value: 2000,
    creditor: {
      slug: 'nubank',
      name: 'Nubank',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/8d256242a2/nubank.svg',
      systemSlug: 'nubank',
    },
    status: 'ACTIVE',
    createdAt: '2025-05-09T03:00:00.000Z',
    contract: 'NU789654123',
    product: 'Empréstimo Pessoal',
    installmentsNumber: 5,
    hasMultipleBills: true,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700576,
      uuid: 'pix123456789abcdef0123456789abcdef0123456789abcdef0123456789abcdef01234567890123456789',
      paymentMethod: 'PIX',
      status: 'UNAVAILABLE',
      number: 5,
      maxPaymentDate: '2025-09-28T03:00:00.000Z',
      dueDate: '2025-09-28T03:00:00.000Z',
      value: 125.75,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700576,
      uuid: 'pix123456789abcdef0123456789abcdef0123456789abcdef0123456789abcdef01234567890123456789',
      paymentMethod: 'PIX',
      status: 'UNAVAILABLE',
      number: 5,
      maxPaymentDate: '2025-09-28T03:00:00.000Z',
      dueDate: '2025-09-28T03:00:00.000Z',
      value: 125.75,
      hidePaymentDueDate: false,
    },
  },

  // Acordo sem parcela para este mês, mas com parcela para o próximo mês
  {
    id: 25855003,
    uuid: 'uuid-itau-003',
    value: 2000,
    creditor: {
      slug: 'itau',
      name: 'Itaú',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/24cb91df83/itau.svg',
      systemSlug: 'itau',
    },
    status: 'ACTIVE',
    createdAt: '2025-08-15T03:00:00.000Z',
    contract: 'IT001234567',
    product: 'Conta Corrente',
    installmentsNumber: 3,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700577,
      uuid: 'itau001122334455667788990011223344556677889900112233445566778899001122',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 1,
      maxPaymentDate: '2025-10-10T03:00:00.000Z',
      dueDate: '2025-10-10T03:00:00.000Z',
      value: 350.0,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700578,
      uuid: 'itau001122334455667788990011223344556677889900112233445566778899001123',
      paymentMethod: 'BILLET',
      status: 'UNAVAILABLE',
      number: 2,
      maxPaymentDate: '2025-11-10T03:00:00.000Z',
      dueDate: '2025-11-10T03:00:00.000Z',
      value: 350.0,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700577,
      uuid: 'itau001122334455667788990011223344556677889900112233445566778899001122',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 1,
      maxPaymentDate: '2025-10-10T03:00:00.000Z',
      dueDate: '2025-10-10T03:00:00.000Z',
      value: 350.0,
      hidePaymentDueDate: false,
    },
  },

  // Acordo ativo com parcela atual já paga
  {
    id: 25855004,
    uuid: 'uuid-bradesco-004',
    value: 2000,
    creditor: {
      slug: 'bradesco',
      name: 'Bradesco',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/f7cf4c97ef/bradesco.svg',
      systemSlug: 'bradesco',
    },
    status: 'ACTIVE',
    createdAt: '2025-07-01T03:00:00.000Z',
    contract: 'BR2025070001',
    product: 'Financiamento Imobiliário',
    installmentsNumber: 12,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700598,
      uuid: '34191790050000006789012345678901234567890123456789012345678901234567890123456789',
      paymentMethod: 'BILLET',
      status: 'PAID',
      number: 4,
      maxPaymentDate: '2025-09-05T03:00:00.000Z',
      dueDate: '2025-09-05T03:00:00.000Z',
      value: 567.8,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700599,
      uuid: '34191790050000007890123456789012345678901234567890123456789012345678901234567890',
      paymentMethod: 'BILLET',
      status: 'UNAVAILABLE',
      number: 5,
      maxPaymentDate: '2025-10-05T03:00:00.000Z',
      dueDate: '2025-10-05T03:00:00.000Z',
      value: 567.8,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700599,
      uuid: '34191790050000007890123456789012345678901234567890123456789012345678901234567890',
      paymentMethod: 'BILLET',
      status: 'UNAVAILABLE',
      number: 5,
      maxPaymentDate: '2025-10-05T03:00:00.000Z',
      dueDate: '2025-10-05T03:00:00.000Z',
      value: 567.8,
      hidePaymentDueDate: false,
    },
  },

  // Acordo ativo com parcela vencida (data já passou)
  {
    id: 258550041,
    uuid: 'expired001',
    value: 1800,
    creditor: {
      slug: 'inter',
      name: 'Banco Inter',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/e3835fe636/acordo-certo.svg',
      systemSlug: 'inter',
    },
    status: 'ACTIVE',
    createdAt: '2025-06-15T03:00:00.000Z',
    contract: 'INT2025061501',
    product: 'Cartão de Crédito Inter',
    installmentsNumber: 8,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700600,
      uuid: '34191790060000008901234567890123456789012345678901234567890123456789012345678901',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE', // Ainda disponível para pagamento mesmo vencida
      number: 3,
      maxPaymentDate: '2025-09-01T03:00:00.000Z',
      dueDate: '2025-09-01T03:00:00.000Z',
      value: 225.0,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700601,
      uuid: '34191790060000009012345678901234567890123456789012345678901234567890123456789012',
      paymentMethod: 'BILLET',
      status: 'UNAVAILABLE',
      number: 4,
      maxPaymentDate: '2025-10-01T03:00:00.000Z',
      dueDate: '2025-10-01T03:00:00.000Z',
      value: 225.0,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700600,
      uuid: '34191790060000008901234567890123456789012345678901234567890123456789012345678901',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 3,
      maxPaymentDate: '2025-09-01T03:00:00.000Z',
      dueDate: '2025-09-01T03:00:00.000Z',
      value: 225.0,
      hidePaymentDueDate: false,
    },
  },

  // Acordo cancelado
  {
    id: 25855005,
    uuid: 'uuid-santander-005',
    value: 2000,
    creditor: {
      slug: 'santander',
      name: 'Santander',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/19010e3970/santander.svg',
      systemSlug: 'santander',
    },
    status: 'CANCELLED',
    createdAt: '2025-06-20T03:00:00.000Z',
    contract: 'ST987654321',
    product: 'Cartão de Crédito Premium',
    installmentsNumber: 6,
    hasMultipleBills: false,
    isOnExternalManagement: false,
  },

  // Acordo pago (finalizado)
  {
    id: 25855006,
    uuid: 'uuid-c6bank-006',
    value: 2000,
    creditor: {
      slug: 'c6bank',
      name: 'C6 Bank',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/af7d196932/c6.svg',
      systemSlug: 'c6bank',
    },
    status: 'PAID',
    createdAt: '2025-03-15T03:00:00.000Z',
    contract: 'C6123456789',
    product: 'Crédito Consignado',
    installmentsNumber: 8,
    hasMultipleBills: false,
    isOnExternalManagement: false,
  },

  // Acordo com parcela PIX deste mês
  {
    id: 25855007,
    uuid: 'uuid-pan-007',
    value: 2000,
    creditor: {
      slug: 'pan',
      name: 'Banco Pan',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/0b1464c858/banco-pan.svg',
      systemSlug: 'pan',
    },
    status: 'ACTIVE',
    createdAt: '2025-08-20T03:00:00.000Z',
    contract: 'PAN456789012',
    product: 'Cartão Consignado',
    installmentsNumber: 4,
    hasMultipleBills: true,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700578,
      uuid: '00020126580014BR.GOV.BCB.PIX0136123e4567-e12b-12d1-a456-426655440000',
      paymentMethod: 'PIX',
      status: 'AVAILABLE',
      number: 2,
      maxPaymentDate: '2025-09-25T03:00:00.000Z',
      dueDate: '2025-09-25T03:00:00.000Z',
      value: 89.9,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700579,
      uuid: '00020126580014BR.GOV.BCB.PIX0136456e7890-e45b-45d4-a789-789012345678',
      paymentMethod: 'PIX',
      status: 'UNAVAILABLE',
      number: 3,
      maxPaymentDate: '2025-10-25T03:00:00.000Z',
      dueDate: '2025-10-25T03:00:00.000Z',
      value: 89.9,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700578,
      uuid: '00020126580014BR.GOV.BCB.PIX0136123e4567-e12b-12d1-a456-426655440000',
      paymentMethod: 'PIX',
      status: 'AVAILABLE',
      number: 2,
      maxPaymentDate: '2025-09-25T03:00:00.000Z',
      dueDate: '2025-09-25T03:00:00.000Z',
      value: 89.9,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com parcela PIX_BILLET deste mês
  {
    id: 25855008,
    uuid: 'uuid-btg-008',
    value: 2000,
    creditor: {
      slug: 'btg',
      name: 'BTG Pactual',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/f0e1cf017b/btg.svg',
      systemSlug: 'btg',
    },
    status: 'ACTIVE',
    createdAt: '2025-07-30T03:00:00.000Z',
    contract: 'BTG789012345',
    product: 'Conta Digital',
    installmentsNumber: 6,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700580,
      uuid: 'PIX_BILLET123456789012345678901234567890123456789012345678901234567890123456',
      paymentMethod: 'PIX_BILLET',
      status: 'AVAILABLE',
      number: 3,
      maxPaymentDate: '2025-09-30T03:00:00.000Z',
      dueDate: '2025-09-30T03:00:00.000Z',
      value: 67.45,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700581,
      uuid: 'PIX_BILLET987654321098765432109876543210987654321098765432109876543210987654',
      paymentMethod: 'PIX_BILLET',
      status: 'UNAVAILABLE',
      number: 4,
      maxPaymentDate: '2025-10-30T03:00:00.000Z',
      dueDate: '2025-10-30T03:00:00.000Z',
      value: 67.45,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700580,
      uuid: 'PIX_BILLET123456789012345678901234567890123456789012345678901234567890123456',
      paymentMethod: 'PIX_BILLET',
      status: 'AVAILABLE',
      number: 3,
      maxPaymentDate: '2025-09-30T03:00:00.000Z',
      dueDate: '2025-09-30T03:00:00.000Z',
      value: 67.45,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com parcela EXTERNA (pagamento no site do parceiro)
  {
    id: 25855009,
    uuid: 'uuid-vivo-009',
    value: 2000,
    creditor: {
      slug: 'vivo',
      name: 'Vivo',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/25d0ce91d1/vivo.svg',
      systemSlug: 'vivo',
    },
    status: 'ACTIVE',
    createdAt: '2025-08-05T03:00:00.000Z',
    contract: 'VV123456789',
    product: 'Plano Móvel Pós-Pago',
    installmentsNumber: 3,
    hasMultipleBills: false,
    isOnExternalManagement: true,
    currentMonthInstallment: {
      id: 8817700582,
      uuid: '',
      paymentMethod: 'EXTERNAL',
      status: 'AVAILABLE',
      number: 1,
      maxPaymentDate: '2025-09-15T03:00:00.000Z',
      dueDate: '2025-09-15T03:00:00.000Z',
      value: 234.5,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700583,
      uuid: '',
      paymentMethod: 'EXTERNAL',
      status: 'UNAVAILABLE',
      number: 2,
      maxPaymentDate: '2025-10-15T03:00:00.000Z',
      dueDate: '2025-10-15T03:00:00.000Z',
      value: 234.5,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700582,
      uuid: '',
      paymentMethod: 'EXTERNAL',
      status: 'AVAILABLE',
      number: 1,
      maxPaymentDate: '2025-09-15T03:00:00.000Z',
      dueDate: '2025-09-15T03:00:00.000Z',
      value: 234.5,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com parcela de débito em conta deste mês
  {
    id: 25855010,
    uuid: 'uuid-caixa-010',
    value: 2000,
    creditor: {
      slug: 'caixa',
      name: 'Caixa Econômica Federal',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/40x40/8a4cd69e8a/caixa.svg',
      systemSlug: 'caixa',
    },
    status: 'ACTIVE',
    createdAt: '2025-06-10T03:00:00.000Z',
    contract: 'CEF987456123',
    product: 'FGTS Emergencial',
    installmentsNumber: 10,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700584,
      uuid: '',
      paymentMethod: 'DEBIT_AUTO',
      status: 'AVAILABLE',
      number: 4,
      maxPaymentDate: '2025-09-10T03:00:00.000Z',
      dueDate: '2025-09-10T03:00:00.000Z',
      value: 156.8,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700585,
      uuid: '',
      paymentMethod: 'DEBIT_AUTO',
      status: 'UNAVAILABLE',
      number: 5,
      maxPaymentDate: '2025-10-10T03:00:00.000Z',
      dueDate: '2025-10-10T03:00:00.000Z',
      value: 156.8,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700584,
      uuid: '',
      paymentMethod: 'DEBIT_AUTO',
      status: 'AVAILABLE',
      number: 4,
      maxPaymentDate: '2025-09-10T03:00:00.000Z',
      dueDate: '2025-09-10T03:00:00.000Z',
      value: 156.8,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com Claro - parcela boleto deste mês, débito subsequente
  {
    id: 25855011,
    uuid: 'uuid-claro-011',
    value: 2000,
    creditor: {
      slug: 'claro',
      name: 'Claro',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/7307bdf4b7/claro.svg',
      systemSlug: 'claro',
    },
    status: 'ACTIVE',
    createdAt: '2025-08-01T03:00:00.000Z',
    contract: 'CL789123456',
    product: 'Internet Banda Larga',
    installmentsNumber: 4,
    hasMultipleBills: true,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700586,
      uuid: '34191790010000001234567890123456789012345678901234567890123456789012345678901234',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 1,
      maxPaymentDate: '2025-09-20T03:00:00.000Z',
      dueDate: '2025-09-20T03:00:00.000Z',
      value: 145.9,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700587,
      uuid: '',
      paymentMethod: 'DEBIT_AUTO',
      status: 'UNAVAILABLE',
      number: 2,
      maxPaymentDate: '2025-10-20T03:00:00.000Z',
      dueDate: '2025-10-20T03:00:00.000Z',
      value: 145.9,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700586,
      uuid: '34191790010000001234567890123456789012345678901234567890123456789012345678901234',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 1,
      maxPaymentDate: '2025-09-20T03:00:00.000Z',
      dueDate: '2025-09-20T03:00:00.000Z',
      value: 145.9,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com Magazine Luiza (Luizacred)
  {
    id: 25855012,
    uuid: 'uuid-luizacred-012',
    value: 2000,
    creditor: {
      slug: 'luizacred',
      name: 'Luizacred',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/244eac525d/luizacred.svg',
      systemSlug: 'luizacred',
    },
    status: 'ACTIVE',
    createdAt: '2025-07-15T03:00:00.000Z',
    contract: 'LC456789123',
    product: 'Cartão de Crédito Magalu',
    installmentsNumber: 7,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700588,
      uuid: '34191790020000002345678901234567890123456789012345678901234567890123456789012345',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 3,
      maxPaymentDate: '2025-09-22T03:00:00.000Z',
      dueDate: '2025-09-22T03:00:00.000Z',
      value: 78.3,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700589,
      uuid: '34191790020000003456789012345678901234567890123456789012345678901234567890123456',
      paymentMethod: 'BILLET',
      status: 'UNAVAILABLE',
      number: 4,
      maxPaymentDate: '2025-10-22T03:00:00.000Z',
      dueDate: '2025-10-22T03:00:00.000Z',
      value: 78.3,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700588,
      uuid: '34191790020000002345678901234567890123456789012345678901234567890123456789012345',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 3,
      maxPaymentDate: '2025-09-22T03:00:00.000Z',
      dueDate: '2025-09-22T03:00:00.000Z',
      value: 78.3,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com Renner
  {
    id: 25855013,
    uuid: 'uuid-renner-013',
    value: 2000,
    creditor: {
      slug: 'lojasrenner',
      name: 'Lojas Renner',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/ec7c84d930/renner.svg',
      systemSlug: 'lojasrenner',
    },
    status: 'ACTIVE',
    createdAt: '2025-06-25T03:00:00.000Z',
    contract: 'RN654321987',
    product: 'Cartão Renner',
    installmentsNumber: 5,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700590,
      uuid: '00020126580014BR.GOV.BCB.PIX0136987f6543-f98b-98f7-f654-321098765432',
      paymentMethod: 'PIX',
      status: 'AVAILABLE',
      number: 4,
      maxPaymentDate: '2025-09-18T03:00:00.000Z',
      dueDate: '2025-09-18T03:00:00.000Z',
      value: 112.0,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700591,
      uuid: '00020126580014BR.GOV.BCB.PIX0136321f0987-f321-321f-f098-765432109876',
      paymentMethod: 'PIX',
      status: 'UNAVAILABLE',
      number: 5,
      maxPaymentDate: '2025-10-18T03:00:00.000Z',
      dueDate: '2025-10-18T03:00:00.000Z',
      value: 112.0,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700590,
      uuid: '00020126580014BR.GOV.BCB.PIX0136987f6543-f98b-98f7-f654-321098765432',
      paymentMethod: 'PIX',
      status: 'AVAILABLE',
      number: 4,
      maxPaymentDate: '2025-09-18T03:00:00.000Z',
      dueDate: '2025-09-18T03:00:00.000Z',
      value: 112.0,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com Via Varejo (Casas Bahia)
  {
    id: 25855014,
    uuid: 'uuid-casasbahia-014',
    value: 2000,
    creditor: {
      slug: 'casas-bahia',
      name: 'Casas Bahia',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/f0aa3e4719/casas-bahia.svg',
      systemSlug: 'casas-bahia',
    },
    status: 'ACTIVE',
    createdAt: '2025-05-20T03:00:00.000Z',
    contract: 'CB321987654',
    product: 'Crediário Casas Bahia',
    installmentsNumber: 12,
    hasMultipleBills: true,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700592,
      uuid: 'PIX_BILLET654321987654321987654321987654321987654321987654321987654321987654',
      paymentMethod: 'PIX_BILLET',
      status: 'AVAILABLE',
      number: 6,
      maxPaymentDate: '2025-09-25T03:00:00.000Z',
      dueDate: '2025-09-25T03:00:00.000Z',
      value: 189.75,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700593,
      uuid: 'PIX_BILLET987654321987654321987654321987654321987654321987654321987654321987',
      paymentMethod: 'PIX_BILLET',
      status: 'UNAVAILABLE',
      number: 7,
      maxPaymentDate: '2025-10-25T03:00:00.000Z',
      dueDate: '2025-10-25T03:00:00.000Z',
      value: 189.75,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700592,
      uuid: 'PIX_BILLET654321987654321987654321987654321987654321987654321987654321987654',
      paymentMethod: 'PIX_BILLET',
      status: 'AVAILABLE',
      number: 6,
      maxPaymentDate: '2025-09-25T03:00:00.000Z',
      dueDate: '2025-09-25T03:00:00.000Z',
      value: 189.75,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com Mercado Livre
  {
    id: 25855015,
    uuid: 'uuid-mercadolivre-015',
    value: 2000,
    creditor: {
      slug: 'mercadolivre',
      name: 'Mercado Livre',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/ca97cec082/mercado-livre.svg',
      systemSlug: 'mercadolivre',
    },
    status: 'ACTIVE',
    createdAt: '2025-08-10T03:00:00.000Z',
    contract: 'ML159753468',
    product: 'Mercado Crédito',
    installmentsNumber: 6,
    hasMultipleBills: false,
    isOnExternalManagement: true,
    currentMonthInstallment: {
      id: 8817700594,
      uuid: '',
      paymentMethod: 'EXTERNAL',
      status: 'AVAILABLE',
      number: 2,
      maxPaymentDate: '2025-09-27T03:00:00.000Z',
      dueDate: '2025-09-27T03:00:00.000Z',
      value: 298.6,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700595,
      uuid: '',
      paymentMethod: 'EXTERNAL',
      status: 'UNAVAILABLE',
      number: 3,
      maxPaymentDate: '2025-10-27T03:00:00.000Z',
      dueDate: '2025-10-27T03:00:00.000Z',
      value: 298.6,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700594,
      uuid: '',
      paymentMethod: 'EXTERNAL',
      status: 'AVAILABLE',
      number: 2,
      maxPaymentDate: '2025-09-27T03:00:00.000Z',
      dueDate: '2025-09-27T03:00:00.000Z',
      value: 298.6,
      hidePaymentDueDate: false,
    },
  },

  // Acordo com Porto Seguro
  {
    id: 25855016,
    uuid: 'uuid-portoseguro-016',
    value: 2000,
    creditor: {
      slug: 'portoseguro',
      name: 'Porto Seguro',
      logoURL: 'https://assets.acordocerto.com.br/f/114280/41x40/c3426de201/porto-seguro.svg',
      systemSlug: 'portoseguro',
    },
    status: 'ACTIVE',
    createdAt: '2025-04-12T03:00:00.000Z',
    contract: 'PS753951486',
    product: 'Seguro Auto',
    installmentsNumber: 8,
    hasMultipleBills: false,
    isOnExternalManagement: false,
    currentMonthInstallment: {
      id: 8817700596,
      uuid: '34191790040000004567890123456789012345678901234567890123456789012345678901234567',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 7,
      maxPaymentDate: '2025-09-14T03:00:00.000Z',
      dueDate: '2025-09-14T03:00:00.000Z',
      value: 423.8,
      hidePaymentDueDate: false,
    },
    nextMonthInstallment: {
      id: 8817700597,
      uuid: '34191790040000005678901234567890123456789012345678901234567890123456789012345678',
      paymentMethod: 'BILLET',
      status: 'UNAVAILABLE',
      number: 8,
      maxPaymentDate: '2025-10-14T03:00:00.000Z',
      dueDate: '2025-10-14T03:00:00.000Z',
      value: 423.8,
      hidePaymentDueDate: false,
    },
    firstUnpaidInstallment: {
      id: 8817700596,
      uuid: '34191790040000004567890123456789012345678901234567890123456789012345678901234567',
      paymentMethod: 'BILLET',
      status: 'AVAILABLE',
      number: 7,
      maxPaymentDate: '2025-09-14T03:00:00.000Z',
      dueDate: '2025-09-14T03:00:00.000Z',
      value: 423.8,
      hidePaymentDueDate: false,
    },
  },
];